import { useIsLandscapeMobile } from '@/lib/useDeviceType';
import React, { useEffect, useState } from 'react';
import { Sheet as TamaguiSheet } from 'tamagui';
import { LessonCompletionContent } from '../LessonCompletionContent';
import { Lesson } from '../../types';
import { Sheet } from './Sheet';

interface LessonCompletionSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  suggestions?: Lesson[];
  onSuggestionPress?: (lesson: Lesson) => void;
  onBack?: () => void;
  courseName?: string;
}

export const LessonCompletionSheet = ({
  open,
  onOpenChange,
  suggestions = [],
  onSuggestionPress,
  onBack,
  courseName
}: LessonCompletionSheetProps) => {
  const [key, setKey] = useState(0);
  const isLandscapeMobile = useIsLandscapeMobile()

  useEffect(() => {
    if (open) {
      // Force re-mount when sheet opens
      setKey(prev => prev + 1);
    }
  }, [open]);

  return (
    <Sheet 
      open={open} 
      onOpenChange={onOpenChange}
      snapPoints={isLandscapeMobile ? [80] : [60]}

    > 
      <TamaguiSheet.ScrollView
          nestedScrollEnabled={false}
          keyboardDismissMode="on-drag"
          scrollEventThrottle={16}
          showsVerticalScrollIndicator={false}
          bounces={false}
          alwaysBounceVertical={false}
          disableScrollViewPanResponder={true}
          contentInsetAdjustmentBehavior="never"
          contentContainerStyle={{ paddingBottom: 24 }}
        >
        <LessonCompletionContent 
          key={key}
          suggestions={suggestions} 
          onClose={() => onOpenChange(false)}
          isMobile={true}
          showCloseButton={true}
          onSuggestionPress={onSuggestionPress}
          onBack={onBack}
          courseName={courseName}
        />
      </TamaguiSheet.ScrollView>
    </Sheet>
  );
};